// Auto-generated: imports for all layout scripts
// This file is maintained by scripts/build-assets.js
// Do not edit manually - changes will be overwritten

import '../../flex/content/layouts/anchor_nav/anchor_nav.js';
import '../../flex/content/layouts/card_slider/card_slider.js';
import '../../flex/content/layouts/expertise_slider/expertise_slider.js';
import '../../flex/content/layouts/faq/faq.js';
import '../../flex/content/layouts/functie_slider/functie_slider.js';
import '../../flex/content/layouts/job_alert/job_alert.js';
import '../../flex/content/layouts/kennis_slider/kennis_slider.js';
import '../../flex/content/layouts/not_found/not_found.js';
import '../../flex/content/layouts/photo_slider/photo_slider.js';
import '../../flex/content/layouts/scroll_text/scroll_text.js';
import '../../flex/content/layouts/statement_image/statement_image.js';
import '../../flex/content/layouts/stats/stats.js';
import '../../flex/content/layouts/story_slider/story_slider.js';
import '../../flex/content/layouts/team_slider/team_slider.js';
import '../../flex/content/layouts/text_stats/text_stats.js';
import '../../flex/content/layouts/vacature_hero/vacature_hero.js';
import '../../flex/content/layouts/vacature_intro/vacature_intro.js';
import '../../flex/content/layouts/video_feature/video_feature.js';
